// Helpers para la plantilla de correo de cumpleaños (misma fuente que usa
// el backend en backend/services/emailTemplates.js: un solo archivo HTML
// con {{placeholders}}, frontend/public/assets/birthdaygifts/
// birthday-email-template.html). Se usan acá para poder mostrar una vista
// previa fiel dentro del panel admin, sin depender de Node/Puppeteer.

import { API_BASE_URL as API, urlDeArchivo } from "../config";

export const BIRTHDAY_TEMPLATE_URL = "/assets/birthdaygifts/birthday-email-template.html";
export const BIRTHDAY_TEMPLATE_CANVAS = { width: 3841, height: 2161 };
const BIRTHDAY_MESSAGE_MAX_LENGTH = 260; // igual que en el backend, ver emailTemplates.js

function escapeHtml(value = "") {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// Misma lógica que backend/services/emailTemplates.js: se recorta por
// palabra completa, nunca a mitad de palabra, para que la vista previa del
// panel admin muestre exactamente lo que va a recibir la persona.
function truncateBirthdayMessage(message) {
  const text = (message || "").toString().trim();
  if (text.length <= BIRTHDAY_MESSAGE_MAX_LENGTH) return text;

  const recorte = text.slice(0, BIRTHDAY_MESSAGE_MAX_LENGTH - 1);
  const ultimoEspacio = recorte.lastIndexOf(" ");
  const limpio = ultimoEspacio > BIRTHDAY_MESSAGE_MAX_LENGTH / 2
    ? recorte.slice(0, ultimoEspacio)
    : recorte;

  return `${limpio.replace(/[s,;:.]+$/, "")}…`;
}

/**
 * Rellena la plantilla cruda (con {{placeholders}} literales) con datos
 * reales. A diferencia del backend (que apunta el fondo a un archivo local
 * vía Puppeteer), acá el fondo y la foto por defecto se resuelven a URLs
 * absolutas del API, para que se vean bien dentro de un <iframe srcDoc>.
 */
export function fillBirthdayTemplate(rawHtml, fields = {}) {
  let html = rawHtml;

  const bgAbsoluteUrl = `${API}/assets/birthdaygifts/Plantilla%20cumplea%C3%B1os%20AA%20Col.jpg`;
  html = html.split("url('Plantilla cumpleaños AA Col.jpg')").join(`url('${bgAbsoluteUrl}')`);

  const defaultPhoto = `${API}/assets/profileCover/DefaultProfile.jpg`;
  const values = {
    employeeName: escapeHtml(fields.employeeName || "Usuario"),
    // El separador " - " forma parte del valor (igual que en el backend):
    // sin cargo no debe quedar un guion suelto detrás del nombre.
    employeePosition: fields.employeePosition
      ? `- ${escapeHtml(fields.employeePosition)}`
      : "",
    // urlDeArchivo convierte "/assets/profile/x.png" en una URL absoluta del
    // backend. Sin esto, dentro del <iframe srcDoc> (que no tiene origen
    // propio) una ruta relativa no resuelve contra nada y la foto sale rota
    // justo en la vista previa, aunque en el correo real se vea bien —el
    // backend ya la resuelve por su cuenta en resolveProfileImage().
    employeePhoto: urlDeArchivo((fields.employeePhoto || "").toString().trim()) || defaultPhoto,
    birthdayDay: escapeHtml(fields.birthdayDay || "XX"),
    birthdayMonth: escapeHtml(fields.birthdayMonth || "JAN"),
    birthdayMessage: escapeHtml(truncateBirthdayMessage(fields.birthdayMessage)),
  };
  for (const [key, value] of Object.entries(values)) {
    html = html.split(`{{${key}}}`).join(value);
  }
  html = html.replace("'/assets/profileCover/DefaultProfile.jpg'", `'${defaultPhoto}'`);

  return html;
}
